import Vue from 'vue'
import HGirlModal from '@/components/modal/girlModal.vue'
const ModalConstructor = Vue.extend(HGirlModal)
let instance = null
function open(type, props) {
  instance = new ModalConstructor({ propsData: { type, ...props } })
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
}
function close() {
  if (instance) {
    instance?.vm?.$destroy()
    instance?.vm?.$el?.parentNode?.removeChild(instance.vm.$el)
  }
}

export default {
  open,
  close
}